// copied from next/packages/graphql/src/resolvers/throwErrorWithResponse.ts b/c of circ dep
export function throwErrorWithResponse(error: any, response: Response): never {
	// Don't swallow the Response object, attach it to the error so the rest of
	// the app has a chance to see it e.g. OnErrorLink:
	if (typeof error === 'object' && error) {
		// At times our various resolver implementations interpret the JSON body of
		// non-OK responses as errors. And sometimes these errors contain a response
		// property (which may be an empty object) that leads to the loss of
		// Response information such as trace ID.
		if ('response' in error) {
			const existingErrorResponse = error.response;

			// Try to attach at least the trace ID to the existing error response:
			if (typeof existingErrorResponse === 'object' && existingErrorResponse) {
				// OnError's getResponseFromError needs the status property:
				if (!('status' in existingErrorResponse)) existingErrorResponse.status = response.status;
				// getTraceIdFromResponse needs the headers property:
				if (!('headers' in existingErrorResponse)) existingErrorResponse.headers = response.headers;
			}
		} else {
			error.response = response;
		}
	}

	throw error;
}
